import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, TextareaModule, ButtonModule, SelectModule, ToastModule],
  providers: [MessageService],
  templateUrl: './contact.html',
  styleUrl: './contact.scss'
})
export class Contact {
  submitting = signal(false);
  submitted = signal(false);

  form = {
    name: '',
    email: '',
    company: '',
    service: null as string | null,
    message: ''
  };

  serviceOptions = [
    { label: 'Custom Software Development', value: 'custom-dev' },
    { label: 'Web Application Development', value: 'web-dev' },
    { label: 'Mobile App Development', value: 'mobile-dev' },
    { label: 'Other', value: 'other' },
  ];

  contactInfo = [
    { icon: 'pi-envelope', label: 'Email', value: 'business@trieon.tech', href: 'mailto:business@trieon.tech' },
    {
      icon: 'pi-map-marker',
      label: 'Address',
      value: 'San Antonio Ave., Brgy. San Antonio, Parañaque City, Philippines',
      href: null,
    },
  ];

  constructor(private messageService: MessageService) {}

  onSubmit() {
    if (!this.form.name || !this.form.email || !this.form.message) return;
    this.submitting.set(true);

    const subject = encodeURIComponent(`Trieon Technologies inquiry from ${this.form.name}`);
    const body = encodeURIComponent(
      `${this.form.message}\n\n— ${this.form.name}\n${this.form.email}${this.form.company ? `\n${this.form.company}` : ''}`
    );
    window.location.href = `mailto:business@trieon.tech?subject=${subject}&body=${body}`;

    setTimeout(() => {
      this.submitting.set(false);
      this.submitted.set(true);
      this.messageService.add({
        severity: 'success',
        summary: 'Draft opened',
        detail: 'Your email client should open with the message ready to send.',
      });
      this.form = { name: '', email: '', company: '', service: null, message: '' };
    }, 600);
  }
}
